import { getFluidExperiencesSetting } from '@fluidx/utilities';
export const mipPhase1SettingName = 'mip.getLabel';
export const mipPhase2SettingName = 'mip.setLabel';
// This will be the flight used to enable PHASE 1 of the MIP rollout
export function isGetLabelEnabled(settingsProvider) {
    return getFluidExperiencesSetting(mipPhase1SettingName, true /* defaultValue */, settingsProvider);
}
// This will be the flight used to enable PHASE 2 of the MIP rollout
export function isSetLabelEnabled(settingsProvider) {
    return getFluidExperiencesSetting(mipPhase2SettingName, false /* defaultValue */, settingsProvider);
}
export function isMIPLocalCacheEnabled(settingsProvider) {
    return getFluidExperiencesSetting('mip.localCacheEnabled', false /* defaultValue */, settingsProvider);
}
//# sourceMappingURL=informationProtectionSettingsUtilities.js.map